import App from 'app/app.js';

function BlockService($window, $rootScope, $filter) {
  var blocked = false,
    toggleBlocked = false,
    cancelCallbacks = [],
    scrollTop = 0;

  var configureBodyOverflow = function (enabled) {
    var body = $('body');

    if (!blocked && !toggleBlocked && !enabled) {
      scrollTop = body.scrollTop();
    }
  };

  var registerCancelCallback = function (cancelCallback) {
    if (cancelCallbacks.indexOf(cancelCallback) < 0) {
      cancelCallbacks.push(cancelCallback);
    }
  };

  var invokeCancelCallbacks = function () {
    while (cancelCallbacks.length > 0) {
      cancelCallbacks.pop()();
    }
  };

  var unblockElement = function (element) {
    configureBodyOverflow(true);
    element.unblock();
    toggleBlocked = false;
    while (cancelCallbacks.length > 0) {
      cancelCallbacks.pop()();
    }
  };

  this.message = '<img src="assets/images/animated_loader.gif" />';

  this.blockUI = function () {
    if (!blocked) {
      blocked = true;

      configureBodyOverflow(false);

      $.blockUI({
        css: {
          border: 'none',
          backgroundColor: '#888888',
          width: 60,
          height: 60,
          '-webkit-border-radius': '4px',
          '-moz-border-radius': '4px',
          'line-height': 4,
          top: ($($window).height() - 60) / 2 + 'px',
          left: ($($window).width() - 60) / 2 + 'px',
          padding: 0,
          'z-index': 9999
        },
        overlayCSS: {
          backgroundColor: '#888888',
          opacity: '0.5',
          'z-index': 9999
        },
        message: this.message
      });
    }
  };

  this.blockCreditCardPage = function (paymentPage) {
    const overlayText = $filter('ltTranslateFilter')('CREDIT_CARD_OVERLAY_TEXT', '');
    const continuePaymentButtonText = $filter('ltTranslateFilter')('CREDIT_CARD_CONTINUE_PAYMENT_BUTTON', '');
    const cancelPaymentButtonText = $filter('ltTranslateFilter')('CREDIT_CARD_CANCEL_PAYMENT_BUTTON', '');
    $.blockUI({
      css: {
        border: 'none',
        '-webkit-border-radius': '4px',
        '-moz-border-radius': '4px',
        'line-height': 2,
        color: 'white',
        top: '',
        left: '',
        backgroundColor: 'none',
        opacity: 1,
        width: '100vw',
        height: '100vh',
        padding: 0,
        'z-index': 9999,
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center'
      },
      overlayCSS: {
        backgroundColor: '#000',
        opacity: '0.7',
        'z-index': 9999
      },
      message: `<div class='overlay-container'>
                    <h1 class='overlay-header'>Lifetouch</h1>
                    <p class='overlay-subtext'>${overlayText}</p>
                    <button class='btn lt-btn overlay-continue-payment'>${continuePaymentButtonText}</button>
                    </br>
                    <a class='overlay-cancel-payment' href='javascript:void(0)'>${cancelPaymentButtonText}</a>
                 </div>`
    });
    $('.overlay-continue-payment')
      .off('click')
      .on('click', function () {
        paymentPage.focus();
      });
    $('.overlay-cancel-payment')
      .off('click')
      .on('click', function () {
        paymentPage.close();
      });
  };

  this.unblockUI = function () {
    if (blocked) {
      configureBodyOverflow(true);
      $.unblockUI();
      blocked = false;
    }
  };

  this.manuallyUnblockUI = function () {
    configureBodyOverflow(true);
    $.unblockUI();
    blocked = false;
  };

  this.toggleBlockBelowMenu = function (state, cancelCallback) {
    this.toggleBlock(state, cancelCallback, 980);
  };

  this.blockBelowDrawer = function () {
    toggleBlocked = false;
    this.toggleBlockBelowDrawer(true);
  };

  this.toggleBlockBelowDrawer = function (state, cancelCallback) {
    this.toggleBlock(state, cancelCallback, 1035);
  };

  this.toggleBlock = function (state, cancelCallback, zIndex) {
    var element = $('#container');

    configureBodyOverflow(!state);

    if (cancelCallback !== undefined) {
      registerCancelCallback(cancelCallback);
    }

    if (!toggleBlocked && state) {
      toggleBlocked = true;

      element.block({
        overlayCSS: {
          backgroundColor: '#888888',
          opacity: '0.5',
          'z-index': zIndex
        },
        message: null
      });

      if (cancelCallbacks.length > 0) {
        $('.blockOverlay').on('mousedown.BlockService', function (e) {
          if (e.which === 1) {
            unblockElement(element);
          }
        });
      }
    } else if (toggleBlocked && !state) {
      $('.blockOverlay').off('mousedown.BlockService');
      unblockElement(element);
    }
  };

  this.setScreenOriginalPosition = function (set) {
    configureBodyOverflow(!set);
  };

  $rootScope.$on('$routeChangeStart', function () {
    scrollTop = 0;
  });
}

App.service('BlockService', ['$window', '$rootScope', '$filter', BlockService]);
